export default function UserController(
  $location,
  $q,
  $rootScope,
  $scope,
  $timeout,
  alerts,
  applications,
  authorizationService,
  confirmDialog,
  editUserDialog,
  editUserCustomerAssignmentsDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  userService
) {
  const vm = this;
  vm.handleShowDeleteUserDialogClick = handleShowDeleteUserDialogClick;
  vm.handleUserStatusChange = handleUserStatusChange;
  vm.handleShowEditUserDialogClick = handleShowEditUserDialogClick;
  vm.handleShowAssignUserCustomersDialogClick = handleShowAssignUserCustomersDialogClick;
  vm.handleImpersonateUserClick = handleImpersonateUserClick;
  vm.handleUnlockUserDialogClick = handleUnlockUserDialogClick;
  vm.handleResendAzureInviteClick = handleResendAzureInviteClick;
  _activate();

  function _activate() {
    userService.getUserPermissionSet('admin').then((permissions) => {
      vm.permissions = permissions;
      userService.getUser().then((user) => {
        // Impersonating users cannot impersonate other users.
        vm.permissions.canImpersonateUser = ((vm.permissions.canImpersonateUser) && (user.impersonatingUserId <= 0));

        if (vm.user.customerId === 1) {
          vm.permissions.canImpersonateUser = vm.permissions.canImpersonateSafeNationalUser;
        }
      });
    });
  }

  function _handleCloseDeleteUserDialogClick() {
    return ssDialogService.hide(ssDialogService.dialogs.admin.userAdministation_deleteUserDialog);
  }

  function _handleYesDeleteUserDialogClick() {
    loaderService.showViewLoader = true;
    const dfdDeleteUser = orgDataService.deleteUser(vm.user.userId);
    dfdDeleteUser.then((isSuccess) => {
      if (isSuccess.status === 200) {
        alerts.success('User has been deleted successfully.');
        $rootScope.$broadcast('refreshUsers');
      } else {
        alerts.error('Error occurred while deleting user.');
      }
      loaderService.showViewLoader = false;
      _handleCloseDeleteUserDialogClick();
    });
  }

  function handleShowDeleteUserDialogClick($event) {
    ssDialogService.dialogs.admin.userAdministation_deleteUserDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete User?',
        message: `Are you sure you want to delete the user "${vm.user.fullName}"?`,
        handleYesClick: () => {
          _handleYesDeleteUserDialogClick();
        },
        handleNoClick: () => {
          _handleCloseDeleteUserDialogClick();
        },
      })
    );
    ssDialogService.show(ssDialogService.dialogs.admin.userAdministation_deleteUserDialog);
  }

  function handleUserStatusChange() {
    loaderService.showViewLoader = true;
    orgDataService.updateUser(vm.user).then((response) => {
      if (response.status !== 200) {
        alerts.error('Error occurred while saving user status.');
      } else {
        alerts.success('User status is updated successfully.');
        $rootScope.$broadcast('handleUserFilterChange');
      }
      loaderService.showViewLoader = false;
    });
  }

  function handleShowEditUserDialogClick($event) {
    loaderService.showViewLoader = true;

    const dfdGetRoles = orgDataService.getRoles(applications.theSafe, vm.customerId);
    const dfdGetUserRoles = orgDataService.getUserRoles(vm.user.userId);
    const customerDomains = orgDataService.getCustomerDomains(vm.customerId);

    $q.all([
      dfdGetRoles,
      dfdGetUserRoles,
      customerDomains
    ]).then((responses) => {
      loaderService.showViewLoader = false;
      const userRoles = userService.combineUserRolesData(
        responses[0].data.result,
        responses[1].data.result
      );
      const _customerDomains = responses[2].data;
      const userCopy = angular.copy(vm.user);

      let _isNonAuthen = false;
      let _isADAuthen = false;
      let _isAzureAuthen = false;
      if (userCopy.authenticationSource === 'None') {
        _isNonAuthen = true;
      } else if (userCopy.authenticationSource === 'ActiveDirectory') {
        _isADAuthen = true;
      } else if (userCopy.authenticationSource === 'azureactivedirectory') {
        _isAzureAuthen = true;
      }

      const custHasUnverifiedEmailDomain = (vm.customerHasUnverifiedEmailDomain === 'true');

      ssDialogService.dialogs.admin.userAdministation_editUserDialog = ssDialogService.alert(
        editUserDialog.getOptions($event, {
          customerId: vm.selectedCustomerId,
          customerHasUnverifiedEmailDomain: custHasUnverifiedEmailDomain,
          userId: userCopy.userId,
          user: userCopy,
          userRoles,
          isNonAuthen: _isNonAuthen,
          isADAuthen: _isADAuthen,
          isAzureAuthen: _isAzureAuthen,
          customerDomains: _customerDomains
        })
      );
      ssDialogService.show(ssDialogService.dialogs.admin.userAdministation_editUserDialog);
    });
  }

  function handleShowAssignUserCustomersDialogClick($event) {
    loaderService.showViewLoader = true;

    const dfdGetCustomers = orgDataService.getVisibleCustomers(vm.user.customerId);
    const dfdGetUserCustomers = orgDataService.getUserCustomerAssignments(vm.user.userId);

    $q.all([
      dfdGetCustomers,
      dfdGetUserCustomers,
    ]).then((responses) => {
      loaderService.showViewLoader = false;
      const userCustomers = userService.combineUserCustomersData(
        responses[0].data,
        responses[1].data
      );
      const userCopy = angular.copy(vm.user);

      ssDialogService.dialogs.admin.editUserCustomerAssignmentsDialog = ssDialogService.alert(
        editUserCustomerAssignmentsDialog.getOptions($event, {
          user: userCopy,
          userCustomers,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.admin.editUserCustomerAssignmentsDialog);
    });
  }

  function handleImpersonateUserClick($event, user) {
    loaderService.showViewLoader = true;
    const dfdGetUserRoles = orgDataService.getUserRoles(user.userId);

    dfdGetUserRoles.then((roleResponse) => {
      if (roleResponse.data.result === undefined || roleResponse.data.result.length <= 0) {
        loaderService.showViewLoader = false;
        alerts.error('Unable to proceed with Impersonation, no role(s) associated for the user.');
      } else {
        orgDataService.impersonate(
          user.userId
        ).then((loginResponse) => {
          if (loginResponse.status === 200) {
            const token = {
              userName: user.loginName,
              access_token: loginResponse.data.access_token,
              access_token_expires_in: loginResponse.data.access_token_expires_in,
              expires_in: loginResponse.data.expires_in,
            };

            authorizationService.setToken(token);
            userService.refreshUser().then(() => {
              $rootScope.$broadcast('loggedIn');
              $location.path('/home');
              $timeout(
                () => {
                  angular.element('html')[0].scrollTop = 0;
                },
                0
              );
            });
          } else {
            alerts.error('Error occurred while impersonating user.');
          }
        }).catch(() => {
          alerts.error('Error occurred while impersonating user.');
        }).finally(() => {
          loaderService.showViewLoader = false;
        });
      }
    });
  }

  function _handleYesUnlockDialog() {
    loaderService.showViewLoader = true;
    orgDataService.unlockUser(
      vm.user
    ).then((response) => {
      if (response.status !== 200) {
        alerts.error('Error occurred while unlocking user.');
      } else {
        alerts.success('User is unlocked successfully.');
        vm.user.isLocked = false;
      }
      loaderService.showViewLoader = false;
      _handleNoUnlockDialog();
    });
  }

  // Transfer Qualified Alert
  function _handleNoUnlockDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.admin.userAdministation_unlockUserDialog);
  }

  function handleUnlockUserDialogClick($event, user) {
    ssDialogService.dialogs.admin.userAdministation_unlockUserDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Unlock User',
        message: `Are you sure you want to unlock user ${vm.user.fullName}?`,
        handleYesClick: () => {
          _handleYesUnlockDialog();
        },
        handleNoClick: () => {
          _handleNoUnlockDialog();
        },
        referenceObject: {
          user
        },
      })
    );
    ssDialogService.show(ssDialogService.dialogs.admin.userAdministation_unlockUserDialog);
  }

  function handleResendAzureInviteClick($event) {
    ssDialogService.dialogs.admin.userAdministation_resendInviteDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Resend Azure Login Invite',
        message: 'Are you sure you want to resend Azure login invite?',
        handleYesClick: () => {
          _handleYesResendDialog();
        },
        handleNoClick: () => {
          _handleNoResendDialog();
        }
      })
    );
    ssDialogService.show(ssDialogService.dialogs.admin.userAdministation_resendInviteDialog);
  }

  // Transfer Qualified Alert
  function _handleNoResendDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.admin.userAdministation_resendInviteDialog);
  }

  function _handleYesResendDialog() {
    loaderService.showViewLoader = true;
    orgDataService.sendAzureInvite(
      vm.user
    ).then((response) => {
      if (response.status !== 200) {
        alerts.error('Error occurred while sending user invite.');
      } else {
        alerts.success('User azure login invite is sent successfully.');
      }
      _handleNoResendDialog();
      loaderService.showViewLoader = false;
    });
  }
}
UserController.$inject = [
  '$location',
  '$q',
  '$rootScope',
  '$scope',
  '$timeout',
  'alerts',
  'applications',
  'authorizationService',
  'confirmDialog',
  'editUserDialog',
  'editUserCustomerAssignmentsDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'userService'
];
